import { RRule } from 'rrule';

const dayNoRRuleWeekMap = [RRule.SU, RRule.MO, RRule.TU, RRule.WE, RRule.TH, RRule.FR, RRule.SA];

export function getRRuleWeekDay(dayNo) {
  return dayNoRRuleWeekMap[dayNo % dayNoRRuleWeekMap.length];
}

export function getDayNoForRRuleWeekDay(rruleWeekDay) {
  return dayNoRRuleWeekMap.findIndex((day) => rruleWeekDay.weekday === day.weekday);
}

export const dayNoWeekDayMap = ['Monday', 'Tuesday', 'Wednesday', 'Thrusday', 'Friday', 'Saturday', 'Sunday'];
